




















































































import Vue from "vue";

export default Vue.extend({
  name: "PipelineBlock",
  data() {
    return {
      screenWidth: <any>null,
      content: [
               {
          code: "DF-006",
          name: "Drug1",
          indication: "Hepatitis B",
          stage: "FIVE",
          stageCount: 6,
        },
        {
          code: "DF-006",
          name: "Drug2",
          indication: "Hepatocellular cancer",
          stage: "FOUR",
          stageCount: 6,
        },
        {
          code: "DF-003",
          name: "Drug3",
          indication: "Cardio-renal disease",
          stage: "FIVE",
          stageCount: 6,
        },
        {
          code: "DF-003",
          name: "Drug4",
          indication: "ROSAH syndrome",
          stage: "SIX",
          stageCount: 6,
        },
        {
          code: "DF-004",
          name: "Drug5",
          indication: "Colitis",
          stage: "TWO",
          stageCount: 6,
        },
        {
          code: "DF-005",
          name: "Drug6",
          indication: "Alzheimer's",
          stage: "TWO",
          stageCount: 6,
        },
        {
          code: "DF-007",
          name: "Drug7",
          indication: "Cancer",
          stage: "TWO",
          stageCount: 6,
        },
		{
          code: "DF-X1",
          name: "Drug8",
          indication: "Colitis",
          stage: "ONE",
          stageCount: 6,
        }
      ],
    };
  },
  methods: {
    bindClassesProgress(stage: string, stageCount: number) {
      const defaultClass = `progress-bar-${stageCount}`;
      const defaultClassNotStarted = `${defaultClass} background-not-started`;
      switch (stage) {
        case "ONE":
          return stageCount === 1
            ? `${defaultClass} background-in-progress`
            : defaultClassNotStarted;
        case "TWO":
          return stageCount === 1
            ? `${defaultClass} background-completed`
            : stageCount === 2
            ? `${defaultClass} background-in-progress`
            : defaultClassNotStarted;
        case "THREE":
          return stageCount < 3
            ? `${defaultClass} background-completed`
            : stageCount === 3
            ? `${defaultClass} background-in-progress`
            : defaultClassNotStarted;
        case "FOUR":
          return stageCount < 4
            ? `${defaultClass} background-completed`
            : stageCount === 4
            ? `${defaultClass} background-in-progress`
            : defaultClassNotStarted;
        case "FIVE":
          return stageCount < 5
            ? `${defaultClass} background-completed`
            : stageCount === 5
            ? `${defaultClass} background-in-progress`
            : defaultClassNotStarted;
        case "SIX":
          return stageCount < 6
            ? `${defaultClass} background-completed`
            : stageCount === 6
            ? `${defaultClass} background-in-progress`
            : defaultClassNotStarted;
        case "COMPLETED":
          return `${defaultClass} background-completed`;
        case "NO":
          return defaultClassNotStarted;
        default:
          return defaultClassNotStarted;
      }
    },
  },
});
